export var CallModalities;
(function (CallModalities) {
    CallModalities["Unknown"] = "unknown";
    CallModalities["Audio"] = "audio";
    CallModalities["Video"] = "video";
    CallModalities["VideoBasedScreenSharing"] = "videoBasedScreenSharing";
    CallModalities["Data"] = "data";
})(CallModalities || (CallModalities = {}));
//# sourceMappingURL=call.js.map